import React from 'react';

const Card = ({ url, title, sourceImage }) => {
  return (
    <div className="w-full">
      <div className="flex justify-center items-center bg-[#F2FAF7] my-6 rounded-lg h-60">
        <img src={sourceImage} alt="-" />
      </div>
      <h5 className="my-3 block text-xl font-bold text-gray-900 text-left">{title}</h5>
      <a
        href={url}
        target="_blank"
        className="block font-base text-primary-500 text-left underline cursor-pointer"
      >
        Buat Perizinan
      </a>
    </div>
  );
};

export default Card;
